import React, { useEffect, useState, useCallback } from 'react';
import { Carousel } from 'react-responsive-carousel';

import callApi from '../../utils/callApi';
import { ANNOUNCEMENTS } from '../../constants/apiUrls/apiUrls';


function Announcements() {
  const [data, setData] = useState([]);

  const getAnnouncements = () => {
    callApi(ANNOUNCEMENTS, 'get').then((res) => {
      if (typeof res.data === 'object') {
        setData(res.data);
      } else {
        setData([]);
      }
    }).catch(() => {
      setData([]);
    });
  };

  const renderAnnouncement = useCallback((announcement) => (
    <a key={announcement?.url} href={announcement?.url} >
      <img alt="announcement" className="announcement-image-desktop" src={announcement?.desktopImage} />
      <img alt="announcement" className="announcement-image-mobile" src={announcement?.mobileImage} />
    </a>
  ), []);


  useEffect(() => {
    getAnnouncements();
  }, []);

  if (!data.length) {
    return null;
  }

  return (
    <Carousel
      autoPlay={true}
      className="announcements-section"
      infiniteLoop={true}
      interval={8000}
      showIndicators={false}
      showStatus={false}
      showThumbs={false}
    >
      {data?.map(renderAnnouncement)}
    </Carousel>
  );
}

export default React.memo(Announcements);
